// Import Styles
import './styles/main.css';

// Import App
import App from './js/core/App.js';

// Initialize app when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}

function initApp() {
  console.log('🚀 GenEdu Portfolio initializing...');
  const app = new App();
  app.init();
}
